import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import {
  PushBracket,
  humanReadablePushBrackets,
} from "../../../types/enums/push-bracket";
import { GroundBiasByPushBracketData } from "../../../types/form/ground-form-modules";
import { BowlingBiasData } from "../../../types/form/player-form-modules";
import { format } from "../../simulator-page/simulator-utils";

export const pushBracketAndGlobalDataComponent = (
  data: GroundBiasByPushBracketData | BowlingBiasData
) => {
  const headers: string[] = [
    "Phase",
    "Actual",
    "Expected",
    "Bias",
    "Balls",
    "Weight",
  ];

  return (
    <Table>
      <TableHead>
        <TableRow>
          {headers.map((header) => (
            <TableCell key={header}>{header}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow key={`data-row-global`}>
          <TableCell>Global</TableCell>
          <TableCell>{format(data.globalActual)}</TableCell>
          <TableCell>{format(data.globalExpected)}</TableCell>
          <TableCell>
            {format(data.globalActual / data.globalExpected)}
          </TableCell>
          <TableCell>{format(data.globalOccurrences)}</TableCell>
          <TableCell>{format(data.globalWeight)}</TableCell>
        </TableRow>
        {Object.keys(PushBracket).map((pushBracket: string, index: number) => (
          <TableRow key={pushBracket}>
            <TableCell>
              {humanReadablePushBrackets[PushBracket[pushBracket]]}
            </TableCell>
            <TableCell>{format(data.totalActual[index])}</TableCell>
            <TableCell>{format(data.totalExpected[index])}</TableCell>
            <TableCell>
              {format(data.totalActual[index] / data.totalExpected[index])}
            </TableCell>
            <TableCell>{format(data.totalBalls[index])}</TableCell>
            <TableCell>{format(data.totalWeights[index])}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
